import {Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ModalController, Platform} from '@ionic/angular';
import {ScreenOrientation} from '@ionic-native/screen-orientation/ngx';
import {BlankSignature} from '../../definitions/blank-signature';
import {DocumentModel} from '../../models/document.model';
import SignaturePad from 'signature_pad';

@Component({
    selector: 'app-draw-signature',
    templateUrl: './draw-signature.page.html',
    styleUrls: ['./draw-signature.page.scss'],
})
export class DrawSignaturePage implements OnInit, OnDestroy {

    @ViewChild('imageCanvas') canvas: ElementRef;
    @Input() document: DocumentModel;
    canvasElement: any;
    signaturePad: any;
    saveX: number;
    saveY: number;
    watch: any;
    screenLoaded: boolean;

    constructor(private plt: Platform,
                private screenOrientation: ScreenOrientation,
                public modalController: ModalController,
                private blankSignature: BlankSignature) {
    }

    ngOnInit() {
        if (this.plt.is('cordova')) {
            this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.LANDSCAPE);
        }
        
        // if (this.document.signature) {
        //     this.initCanvas();
        // }
        // this.detectOrientationChange();
    }

    ionViewWillEnter() {
        console.log('Did enter');

        this.canvasElement = this.canvas.nativeElement;
        this.setCanvasWidthAndHeight();
        
        console.log('Width Height', window.innerWidth, window.innerHeight);
        this.signaturePad = new SignaturePad(this.canvasElement);
        this.screenLoaded = true;
    }

    setCanvasWidthAndHeight(){
        var width = window.innerWidth; // freeze values
        var height = window.innerHeight;

        if( height > width ){ // we are still in portrait ( race condition ? )
            this.canvasElement.width = height * 0.995;
            this.canvasElement.height = width * 0.55;
        } else{
            this.canvasElement.width = width * 0.995;
            this.canvasElement.height = height * 0.55;
        }
    }


    initCanvas() {
        const signature = new Image();
        const ctx = this.canvasElement.getContext('2d');
        signature.src = this.document.signature;
        ctx.clearRect(0, 0, this.canvasElement.width, this.canvasElement.height);
        ctx.drawImage(signature, 0, 0);
    }

    detectOrientationChange() {
        this.watch = this.screenOrientation.onChange().subscribe(() => {
            console.log('Orientation Changed');

        });
    }

    startDrawing(ev) {

        const canvasPosition = this.canvasElement.getBoundingClientRect();

        this.saveX = ev.touches[0].pageX - canvasPosition.x;
        this.saveY = ev.touches[0].pageY - canvasPosition.y;

    }

    moved(ev) {
        const canvasPosition = this.canvasElement.getBoundingClientRect();

        const ctx = this.canvasElement.getContext('2d');
        const currentX = ev.touches[0].pageX - canvasPosition.x;
        const currentY = ev.touches[0].pageY - canvasPosition.y;

        ctx.lineJoin = 'round';
        ctx.lineWidth = 1;

        ctx.beginPath();
        ctx.moveTo(this.saveX, this.saveY);
        ctx.lineTo(currentX, currentY);
        ctx.closePath();

        ctx.stroke();

        this.saveX = currentX;
        this.saveY = currentY;
    }

    clearCanvas() {
        this.signaturePad.clear();
        // const ctx = this.canvasElement.getContext('2d');
        // ctx.clearRect(0, 0, this.canvasElement.width, this.canvasElement.height);
    }

    saveCanvas() {
        const dataURL = this.signaturePad.toDataURL();
        console.log(dataURL);
        this.modalController.dismiss(dataURL);
    }

    ionViewWillLeave() {
        this.screenOrientation.unlock();
        console.log(this.screenOrientation.type);
    }

    ngOnDestroy(): void {
    }
}
